// EditMilestoneDrawer.js
import React, { useEffect, useState } from "react";
import Drawer from "@mui/material/Drawer";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  TextField,
  Button,
} from "@mui/material";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Action } from "../../constants/Common";
import {
  createProjectType,
  updateProjectType,
} from "../../api/casp/projectType";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import { withTranslation } from "react-i18next";
const AddProjectTypeDrawer = ({
  isOpen,
  emitItem,
  handleClose,
  toggleDrawer,
  data,
  actionType = Action.CREATE,
  t
}) => {
  const [projectTypeObject, setProjectTypeObject] = useState({
    name: "",
    description: "",
  });
  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setProjectTypeDetails();
  }, []);

  const setProjectTypeDetails = () => {
    if (data) {
      setProjectTypeObject({
        name: data.name,
        description: data.description,
      });
      formik.setValues({
        name: data.name,
        description: data.description,
      });
    } else {
      return;
    }
  };

  const projectTypeValidation = Yup.object().shape({
    name: Yup.string()
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .max(250, t("Name can not be greater than 250 characters"))
      .trim().required(t('Name is required')),
    description: Yup.string()
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .max(2000, t("Description can not be greater than 2000 characters"))
      .trim(),
  })

  const formik = useFormik({
    initialValues: {
      ...projectTypeObject,
    },
    validationSchema: projectTypeValidation,
    validateOnMount: true,
    onSubmit: () => {
      handleUpdate();
    },
  });

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      let payload = {
        name: formik.values.name.trim(),
        ...(formik.values.description.trim() && {
          description: formik.values.description.trim()
        })
      };
      const result = await createProjectType(payload);
      if (result.statusCode === 200) {
        toast.success(result.data.message);
      }
      formik.resetForm();
      emitItem();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleUpdate = async () => {
    try {
      setIsLoading(true);
      let payload = {
        name: formik.values.name,
        description: formik.values.description,
      };
      const result = await updateProjectType(data?.id, payload);
      if (result.statusCode === 200) {
        toast.success(result.data.message);
      }
      formik.resetForm();
      emitItem();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const reset = () => {
    formik.resetForm();
    handleClose();
  };

  useEffect(() => {
    if (formik.values.name.trim()) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [formik.values]);
  return (
    <Drawer anchor="right" open={isOpen} onClose={(_, reason) => () => {
      if (reason !== 'backdropClick') {
        handleClose()
      }
    }}>
      <div style={{ width: "500px" }} className="editProjTypeDrawer">
        <List>
          <ListItem>
            <ListItemText>{t("Add Startup Type")}</ListItemText>
            <ListItemIcon>
              <IconButton onClick={reset}>
                <CancelOutlinedIcon />
              </IconButton>
            </ListItemIcon>
          </ListItem>
          <ListItem>
            <TextField
              fullWidth
              id="outlined-basic"
              label={t("Startup Type")}
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              required
            />
          </ListItem>
          <div className="mx-3">
            {formik.touched.name && formik.errors.name && (
              <span className="text-danger">{formik.errors.name}</span>
            )}
          </div>
          <ListItem>
            <TextField
              fullWidth
              id="outlined-basic"
              label={t("Description")}
              name="description"
              multiline
              rows={4}
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </ListItem>
          <div className="mx-3">
            {formik.touched.description && formik.errors.description && (
              <span className="text-danger">{formik.errors.description}</span>
            )}
          </div>
          <ListItem className="justify-content-center">
            <Button
              onClick={() => {
                actionType === Action.EDIT ? handleUpdate() : handleSubmit();
              }}
              variant="contained"
              type="submit"
              className="drawerCommonBtn greenBtn mx-2"
              disabled={isDisabled || isLoading}
            >
              {t("Submit")}
            </Button>
            {isLoading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-1"
              />
            )}
            <span className="visually-hidden">{t("Loading") + '...'}</span>
            <Button
              onClick={() => {
                reset();
              }}
              variant="contained"
              className="drawerCommonBtn redButton"
            >
              {t("Cancel")}
            </Button>
          </ListItem>
        </List>
      </div>
    </Drawer>
  );
};

export default withTranslation()(AddProjectTypeDrawer);
